export default __webpack_public_path__ + "static/media/closer_army.a6f922de.mp3";